// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-card[data-v-4c4e6323] {\r\n  border: solid 0.3rem var(--v-warning-base);\n}\r\n", ""]);
// Exports
module.exports = exports;
